export default {
    "nl":{
        'kevin':'nl Kevin',
        'READ_MORE':'Lees meer'
    },
    "en":{
        'kevin':' en Kevin',
        'READ_MORE':'Read more'
    }
}